document.addEventListener("DOMContentLoaded", () => {
  // Flip logo
  const flip = document.querySelector(".logo-flip");

  if (flip) {
    const front = flip.querySelector(".front");
    const back = flip.querySelector(".back");

    // On vérifie que tout existe
    if (front && back) {
      gsap.set(back, { rotateY: 180 });
      gsap.set([front, back], { transformOrigin: "50% 50%" });

      let tl = gsap
        .timeline({ paused: true })
        .to(front, { rotateY: -180, duration: 0.7, ease: "power3.inOut" }, 0)
        .to(back, { rotateY: 0, duration: 0.7, ease: "power3.inOut" }, 0);

      flip.addEventListener("mouseenter", () => tl.play());
      flip.addEventListener("mouseleave", () => tl.reverse());
    }
  }
});
